/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import FrameImageWork from './FrameImageWork';
import Parser from 'html-react-parser';

export default class FrameArea extends Component {

	constructor(props, context) {
		super(props, context);
		this.getWidth = this.getWidth.bind(this);
	}

	componentDidMount() {
        this.getWidth();
        window.addEventListener('resize', this.getWidth);
    }

	componentWillUnmount() {
        window.removeEventListener('resize', this.getWidth);
    }

	getWidth() {
        this.props.dispatch({
            type: 'SET_STATE',
            state: {
                leftWidth: this.divLeft.clientWidth,
            }
        })
    }

	render() {
		const {wallcolor, canvasImage, selectedmatBoard} = this.props;
		//console.log(selectedmatBoard.size)
		const styles = {
			wallColorBg: {backgroundColor: wallcolor, height: this.props.rightFrameHeight}
		};
		return (
			<div className="img_set_sec" style={styles.wallColorBg} ref={element => this.divLeft = element}>
				<FrameImageWork
	    			{...this.props} />
				<Modal
					show={this.props.lgShow}
					onHide={this.props.lgClose}
					bsSize="large"
				>
					<Modal.Header closeButton>
			        	<Modal.Title id="contained-modal-title-lg">{selectedmatBoard.size > 0 ? Parser(selectedmatBoard.get('name')) : ''}</Modal.Title>
			        </Modal.Header>
					<Modal.Body>
						<div style={{ textAlign: 'center' }} className="popup-wrapper">
							<img src={canvasImage} alt={selectedmatBoard.size > 0 ? Parser(selectedmatBoard.get('name')) : ''} />
						</div>
					</Modal.Body>
				</Modal>
		    </div>
	    );
	}
}